import { animateInit } from './about/animation'
import { aboutMenuInit } from './about/menu'
import { sliderInit } from './about/slider'
import { teamInit } from './about/team'

document.addEventListener('DOMContentLoaded', () => {
  aboutMenuInit()
  sliderInit()
  teamInit()
  animateInit()
})
